import { api } from './client';

export interface NotificationItem {
  id: string;
  userId: string;
  type: string;
  title: string;
  message: string;
  relatedResourceId?: string | null;
  relatedResourceType?: string | null;
  isRead: boolean;
  readAt?: string | null;
  expiresAt?: string | null;
  createdAt: string;
}

export interface NotificationsMeta {
  current_page: number;
  last_page: number;
  total: number;
  unread_count: number;
}

export function getNotifications(page = 1, type?: string) {
  const params = new URLSearchParams({ page: String(page), per_page: '20' });
  if (type) params.set('type', type);
  return api<{ data: NotificationItem[]; meta: NotificationsMeta }>(
    `/notifications?${params}`
  );
}

export interface AnnouncementAttachment {
  filename: string;
  url: string;
}

export interface AnnouncementItem {
  id: string;
  title: string;
  body: string;
  sentAt: string;
  attachments: AnnouncementAttachment[];
}

export interface AnnouncementsMeta {
  current_page: number;
  last_page: number;
  total: number;
}

export function getAnnouncements(page = 1) {
  const params = new URLSearchParams({ page: String(page), per_page: '20' });
  return api<{ data: AnnouncementItem[]; meta: AnnouncementsMeta }>(
    `/announcements?${params}`
  );
}

export function markNotificationRead(id: string) {
  return api<{ data: NotificationItem }>(`/notifications/${id}/read`, {
    method: 'PATCH',
  });
}

export function markAllNotificationsRead() {
  return api<{ message: string }>('/notifications/read-all', {
    method: 'PATCH',
  });
}
